import React from 'react';
import { GraduationCap, ShieldCheck, Leaf } from 'lucide-react';
import { credentials, therapistImage } from '../data/mock';

const iconMap = { GraduationCap, ShieldCheck, Leaf };

const Therapist = () => {
  return (
    <section id="therapist" className="relative bg-[#F4EFE7] pt-24 md:pt-28 lg:pt-36 pb-24 md:pb-28 lg:pb-36 overflow-hidden">
      <div className="vertical-divider hidden lg:block"></div>

      <div className="max-w-[1400px] mx-auto relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-0 items-start">
          {/* Left column */}
          <div className="px-8 lg:pl-12 lg:pr-16 lg:pt-16">
            <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-6">
              03 &nbsp;—&nbsp; ALLA ALGHAZAWI, RMT
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#1E1B18] mb-6 md:mb-8">
              Trained to read the body, not just treat it
            </h2>
            <p className="text-[14px] md:text-[15px] text-[#1E1B18]/70 leading-relaxed mb-10 md:mb-12 max-w-lg">
              Every session begins with an assessment — reading the story your tissue tells. Treatment then follows, using techniques such as kneading, trigger point therapy, assisted stretching, cupping, or lymphatic drainage, so you leave feeling your best.
            </p>

            <div className="space-y-6">
              {credentials.map((c) => {
                const Icon = iconMap[c.icon];
                return (
                  <div key={c.title} className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-full bg-[#E5DDF0] flex items-center justify-center shrink-0">
                      <Icon size={18} className="text-[#7B6BA6]" strokeWidth={1.6} />
                    </div>
                    <div>
                      <h4 className="text-[15px] font-medium text-[#1E1B18] mb-0.5">{c.title}</h4>
                      <p className="text-[13px] text-[#1E1B18]/60">{c.subtitle}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right column — tall image extending to the section edge with soft top fade */}
          <div className="relative w-full h-[420px] md:h-[560px] lg:h-[720px] px-8 lg:px-0 lg:-mt-16">
            <div className="relative w-full h-full overflow-hidden bg-[#EFE8DD]">
              <img
                src={therapistImage}
                alt="The registered massage therapist, focused and calm"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
              {/* Soft fade at the top blending into the beige background */}
              <div
                className="pointer-events-none absolute inset-x-0 top-0 h-32 lg:h-40"
                style={{
                  background:
                    'linear-gradient(to bottom, #F4EFE7 0%, rgba(244,239,231,0.7) 45%, rgba(244,239,231,0) 100%)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Therapist;
